import * as React from 'react';
import { SVGProps } from 'react';

const IconMMPSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 1v1h-.635l.931 5H10v1H2V7h1.704l.931-5H4V1h4ZM5.429 3H6.57l.699 4H4.73l.699-4Z"
    />
    <path d="M11 9.99V11a1.774 1.774 0 0 1-.95-.183l-1.256-.623-.73.483a1.781 1.781 0 0 1-1.9.072l-.894-.507-.347.275c-.644.511-1.474.56-2.16.106l-.685-.453L1 10.7V9.586l.721-.356.019-.007a.926.926 0 0 1 .86.093l.714.472c.315.209.672.196.988-.054l.371-.295a.93.93 0 0 1 1.053-.088l.932.528a.782.782 0 0 0 .854-.036l.758-.501a.926.926 0 0 1 .933-.061l1.291.64a.768.768 0 0 0 .506.07Z" />
  </svg>
);
export default IconMMPSizeXs;
